export const PREVIEW_COURSE_TYPE = {
    'SINGLE': 0,
    'TEAM': 1
}

export const PREVIEW_COURSE_PERIOD = {
    'DAY': 0,
    'HALF_DAY': 1
}